import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
  useDisclosure,
  useToast,
  Link,
  Select,
  ModalCloseButton,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { ValidationError, useForm } from "@formspree/react";

export const Involved = ({ button, title, text, thanks }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);

  const [activeEventIndex, setActiveEventIndex] = useState(null);

  const handleEventClick = (index: any) => {
    setActiveEventIndex(index);
  };

  var toast = useToast();

  const [state, handleSubmit] = useForm("maygojnn");

  if (state.succeeded) {
    toast({
      status: "success",
      title:
        "Thank you for completing the form. You will be contacted by a GTA representative.",
    });
  }

  return (
    <>
      <Button
        onClick={onOpen}
        display={"flex"}
        p={0}
        bg={"transparent"}
        color={"#D9A542"}
        fontSize={"md"}
        textTransform={"uppercase"}
        aria-label="get-involved"
        _hover={{ bg: "transparent" }}
      >
        {button}
      </Button>

      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent
          w={{ base: "auto", md: "880px" }}
          h={"auto"}
          py={10}
          px={{ base: 0, md: 20 }}
          maxW={"100%"}
          backgroundImage={"/form-volunteer.svg"}
          bgColor={"#F2F4F2"}
          borderRadius={"none"}
        >
          <HStack
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            textAlign={"center"}
          >
            <ModalHeader
              fontSize={{ base: "4xl", md: "5xl" }}
              fontFamily={"TradeGothic LT Bold"}
              lineHeight={"115%"}
              fontWeight={"bold"}
              color={"#09170D"}
              textTransform={"uppercase"}
              pt={0}
            >
              {title}
            </ModalHeader>
            <Text fontSize={"lg"} color={"#768178"}>
              {text}
            </Text>
            <Text fontWeight={"bold"}>{thanks}</Text>
          </HStack>
          <form onSubmit={handleSubmit}>
            <ModalCloseButton />
            <ModalBody py={6}>
              <Flex direction="column">
                <Flex gap={6} flexDir={{ base: "column", md: "row" }}>
                  <FormControl flex="1" isRequired>
                    <FormLabel
                      htmlFor="fullName"
                      pl={4}
                      fontSize="sm"
                      color="#768178"
                    >
                      Full Name
                    </FormLabel>
                    <Input
                      id="fullName"
                      type="text"
                      name="fullName"
                      bg="white"
                      border="1px solid #D9DEDA"
                      borderRadius={"none"}
                      py={3}
                      px={4}
                      ref={initialRef}
                      placeholder="Full name"
                      _focus={{ border: "1px solid #B2BB42" }}
                      _focusVisible={{ border: "1px solid #B2BB42" }}
                    />
                  </FormControl>
                  <FormControl flex="1">
                    <FormLabel
                      htmlFor="address"
                      pl={4}
                      fontSize="sm"
                      color="#768178"
                    >
                      Address
                    </FormLabel>
                    <Input
                      id="address"
                      type="text"
                      name="address"
                      bg="white"
                      border="1px solid #D9DEDA"
                      borderRadius={"none"}
                      py={3}
                      px={4}
                      placeholder="Address"
                      _focus={{ border: "1px solid #B2BB42" }}
                      _focusVisible={{ border: "1px solid #B2BB42" }}
                    />
                  </FormControl>
                </Flex>
                <Flex gap={6} flexDir={{ base: "column", md: "row" }}>
                  <FormControl flex="1" mt={4} isRequired>
                    <FormLabel
                      htmlFor="phone"
                      pl={4}
                      fontSize="sm"
                      color="#768178"
                    >
                      Phone
                    </FormLabel>
                    <Input
                      id="phone"
                      type="number"
                      name="phone"
                      bg="white"
                      border="1px solid #D9DEDA"
                      borderRadius={"none"}
                      py={3}
                      px={4}
                      placeholder="Phone"
                      _focus={{ border: "1px solid #B2BB42" }}
                      _focusVisible={{ border: "1px solid #B2BB42" }}
                    />
                  </FormControl>
                  <FormControl flex="1" mt={{ base: 0, md: 4 }} isRequired>
                    <FormLabel
                      htmlFor="city"
                      pl={4}
                      fontSize="sm"
                      color="#768178"
                    >
                      City, State, Zip Code
                    </FormLabel>
                    <Input
                      id="city"
                      type="text"
                      name="city"
                      bg="white"
                      border="1px solid #D9DEDA"
                      borderRadius={"none"}
                      py={3}
                      px={4}
                      placeholder="City, State, Zip Code"
                      _focus={{ border: "1px solid #B2BB42" }}
                      _focusVisible={{ border: "1px solid #B2BB42" }}
                    />
                  </FormControl>
                </Flex>
                <Flex gap={6} flexDir={{ base: "column", md: "row" }}>
                  <FormControl flex="1" mt={4} isRequired>
                    <FormLabel
                      htmlFor="email"
                      pl={4}
                      fontSize="sm"
                      color="#768178"
                    >
                      Email
                    </FormLabel>
                    <ValidationError
                      prefix="Email"
                      field="email"
                      errors={state.errors}
                    />
                    <Input
                      id="email"
                      type="email"
                      name="email"
                      bg="white"
                      border="1px solid #D9DEDA"
                      borderRadius={"none"}
                      py={3}
                      px={4}
                      placeholder="Email"
                      _focus={{ border: "1px solid #B2BB42" }}
                      _focusVisible={{ border: "1px solid #B2BB42" }}
                    />
                  </FormControl>
                  <FormControl flex="1" mt={{ base: 0, md: 4 }} isRequired>
                    <FormLabel
                      htmlFor="activity"
                      pl={4}
                      fontSize="sm"
                      color="#768178"
                    >
                      Activity
                    </FormLabel>

                    <Select
                      id="activity"
                      name="activity"
                      bg="white"
                      border="1px solid #D9DEDA"
                      borderRadius={"none"}
                      placeholder="Activity"
                      _focus={{ border: "1px solid #B2BB42" }}
                      _focusVisible={{ border: "1px solid #B2BB42" }}
                    >
                      <option value="Accompany International Visitors to meetings as a GTA Local Guide">
                        Accompany International Visitors to meetings as a GTA
                        Local Guide
                      </option>
                      <option value="Assist with Planning and Setup for Events">
                        Assist with Planning and Setup for Events
                      </option>
                      <option value="Donate Professional Services (photography, videography, etc.)">
                        Donate Professional Services (photography, videography,
                        etc.)
                      </option>
                      <option value="Greet International Visitors at the Airport">
                        Greet International Visitors at the Airport
                      </option>
                      <option value="Have Dinner with International Visitors at a Local Restaurant">
                        Have Dinner with International Visitors at a Local
                        Restaurant
                      </option>
                      <option value="Host International Visitors in my home for Dinner (Home Hospitality)">
                        Host International Visitors in my home for Dinner (Home
                        Hospitality)
                      </option>
                      <option value="Host International Visitors in my home Overnight (Home Host)">
                        Host International Visitors in my home Overnight (Home
                        Host)
                      </option>
                      <option value="Meet with International Visitors to share Professional Expertise">
                        Meet with International Visitors to share Professional
                        Expertise
                      </option>
                      <option value="Youth Ambassador Exchange Programs">
                        Youth Ambassador Exchange Programs
                      </option>
                      <option value="Take International Visitors Shopping">
                        Take International Visitors Shopping
                      </option>
                      <option value="Learn more about GTA">
                        Learn more about GTA
                      </option>
                      <option value="Other (Write-In)">Other (Write-In)</option>
                    </Select>
                  </FormControl>
                </Flex>
                <FormControl mt={4}>
                  <FormLabel
                    htmlFor="message"
                    pl={4}
                    fontSize="sm"
                    color="#768178"
                  >
                    Fluent in any foreign languages? Which ones?
                  </FormLabel>
                  <Textarea
                    id="message"
                    name=",essage"
                    bg="white"
                    border="1px solid #D9DEDA"
                    borderRadius={"none"}
                    py={3}
                    px={4}
                    placeholder="Yes! I speak..."
                    _focus={{ border: "1px solid #B2BB42" }}
                    _focusVisible={{ border: "1px solid #B2BB42" }}
                  />
                  <ValidationError
                    prefix="Message"
                    field="message"
                    errors={state.errors}
                  />
                </FormControl>
              </Flex>
              <Link _hover={{ textDecortaion: "none" }}>
                <Button
                  bg={"#D9A542"}
                  color={"white"}
                  px={8}
                  w={28}
                  h={10}
                  display={"flex"}
                  mt={6}
                  mx={"auto"}
                  textTransform={"uppercase"}
                  borderRadius={0}
                  fontWeight={"700"}
                  aria-label="submit-form"
                  _hover={{
                    bg: "#D9A542",
                  }}
                  type="submit"
                  disabled={state.submitting}
                >
                  SUBMIT
                </Button>
              </Link>
            </ModalBody>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
};
